import { environment } from '@root/src/environments/environment';

// The map needs an XYZ URL template. API client 2.20.8 still has no template builder
// for GetTileByLayer; keep this adapter until one is generated.
export function buildSnapshotTileUrl(productId: string): string {
  const layer = `satellite:satellite_product_${productId}`;
  return (
    `${environment.api}/tiles/Map/GetTileByLayer?x={x}&y={y}&z={z}` +
    `&layer=${encodeURIComponent(layer)}&coordinateSystem=0`
  );
}
